import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsFile, SideBySideCarouselAndText } from 'www-cms';
import { DirectusDirective } from 'directus';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { CarouselControlsComponent } from '../../shared/components/carousel-controls/carousel-controls.component';

@Component({
  selector: 'ss-www-side-by-side-carousel-text',
  imports: [
    CommonModule,
    ImageWithLoaderComponent,
    CarouselControlsComponent,
    DirectusDirective,
  ],
  templateUrl: './side-by-side-carousel-text.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideBySideCarouselTextComponent extends BaseBuildingBlockComponent {
  @Input({ required: true })
  sideBySideCarouselAndTextData!: SideBySideCarouselAndText;
  currentIndex = signal<number>(0);

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }

  imgTackBy(index: number, img: CmsFile) {
    return img.directus_files_id.id;
  }
}
